import React, {Suspense} from 'react';
import {isRunningOnClientSide} from '../../../../../../../../../utils/func';
import { useSelector } from 'react-redux';
const QuizPreview = React.lazy( () => import('./QuizPreview.jsx') );
import ErrorBoundary from '../../../../../../../../../components/errorBoundary/ErrorBoundary';

const QuizPreviewAsync  = ( { props } ) => {
    const { localization: { content } } = useSelector( state => state );

    if(isRunningOnClientSide()) {
        return (
            <ErrorBoundary>
                <Suspense fallback={ <div>{ content.loading }</div> }>
                    <QuizPreview  { ...props }/>
                </Suspense>
            </ErrorBoundary>
        );
    } else return null;
};

export default QuizPreviewAsync;
